
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const { isAuthenticated, user } = useSelector(state => state.auth);
  
  // Check authentication
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  // Check permissions if required
  if (requiredPermissions.length > 0 && user) {
    // Add your permission logic here based on user.type_id or other fields
    const hasPermission = true; // Implement your permission logic
    if (!hasPermission) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  
  return children;
};

export default ProtectedRoute;
